import { DateInput } from '@/components/inputs/DateInput'
import {
  FilterViewDivider,
  FilterViewHeader,
  FilterViewItem,
  FilterViewItemGroup,
} from '@/components/FilterControls'

interface DateRangeFilterViewProps {
  title: string
  from?: Date
  to?: Date
  onFromChange: (value: Date) => void
  onToChange: (value: Date) => void
  onClear: () => void
  testId?: string
}

/**
 * Editor for a filter on a range of dates.
 */
export function DateRangeFilterView({
  title,
  from,
  to,
  onFromChange,
  onToChange,
  onClear,
  testId,
}: DateRangeFilterViewProps) {
  return (
    <>
      <FilterViewHeader
        title={title}
        testId={testId && `${testId}-clear-button`}
        onClear={onClear}
      />
      <FilterViewItemGroup>
        <FilterViewItem title="Date from">
          <DateInput
            icon="change-start-date"
            compact={true}
            testId={testId && `${testId}-from-field`}
            value={from}
            onChange={onFromChange}
          />
        </FilterViewItem>
        <FilterViewDivider />
        <FilterViewItem title="Date to">
          <DateInput
            icon={'override-deadline'}
            compact={true}
            testId={testId && `${testId}-to-field`}
            value={to}
            onChange={onToChange}
          />
        </FilterViewItem>
      </FilterViewItemGroup>
    </>
  )
}
